import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectTaskTableSetting = state => {
    return selectOwnState(state).taskListTableSettings
}

export const selectStateTableSetting = state => {
    return selectOwnState(state).stateListTableSettings
}

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectUserSelection = (state) => {
    return selectOwnState(state).userSelection
}

export const selectStateAnalytics = state => {
    return selectOwnState(state).stateAnalytics
}

export const selectTaskByDueDateList = state => {
    return selectOwnState(state).taskByDueDateList
}

export const selectTaskWeekDiffByIndex = (state, index) => {
    const lastChangeList = selectTaskByDueDateList(state)
    const lastChange = lastChangeList[index]
    return lastChange.weekDiff
}


export const selectStateByLastChangedList = state => {
    return selectOwnState(state).stateByLastChangedList
}

export const selectStatekDiffByIndex = (state, index) => {
    const lastChangeList = selectStateByLastChangedList(state)
    const lastChange = lastChangeList[index]
    return lastChange.weekDiff
}


export const selectCurrentStateName = state => {
    return selectOwnState(state).currentStateName
}

export const selectCurrentTaskName = state => {
    return selectOwnState(state).currentTaskName
}

export const selectTaskList = state => {
    return selectOwnState(state).taskList
}

export const selectProcessInstanceList = state => {
    return selectOwnState(state).processInstanceList
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/state-responsible/selector.js